import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';

import Login from '~/Pages/Login/Login';
import ResetCode from '~/Pages/ResetCode/ResetCode';
import Invitation from '~/Pages/Invitation/Invitation';
import Experiance from '~/Pages/Experiance/Experiance';
import RsvpDecline from '~/Pages/RsvpDecline/RsvpDecline';
import RsvpConfirm from '~/Pages/RsvpConfirm/RsvpConfirm';
import RsvpRegistration from '~/Pages/RsvpRegistration/RsvpRegistration';
import RsvpPreview from '~/Pages/RsvpPreview/RsvpPreview';
import Faq from '~/Pages/Faq/Faq';
import Contact from '~/Pages/Contact/Contact';
import HostContacts from "~/Pages/HostLanding/HostContacts";
import Admin from '~/Admin/Admin';

import AppLoader from '~/AppLoader';
import AppRedirect from '~/AppRedirect';
import GAListener from '~/GAListener';
import ProtectedRoute from '~/permissions/ProtectedRoute';
import store from '~/redux/store';
import 'react-dates/initialize';

import '~/styles/styles.scss';
import MyProfile from '../Pages/MyProfile/MyProfile';

class App extends Component {

    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <Provider store={store}>
                <AppLoader>
                    <BrowserRouter>
                        <GAListener>
                            <AppRedirect>
                                <Switch>
                                    <Route exact path='/admin' component={Admin} />

                                    <Route exact path='/' component={Login} />
                                    <Route exact path='/reset-code' component={ResetCode} />
                                    {/* <Route exact path='/host/:uuid' component={HostLanding}/>       // REQUESTED REMOVE LDT-2312 */}
                                    <Route exact path='/host-contacts/:uuid' component={HostContacts} />
                                    {/* <Route path='/terms/:tab?' component={Legal}/> */}
                                    <Route path='/contact' component={Contact} />

                                    <ProtectedRoute path='/invitation' component={Invitation} />
                                    <ProtectedRoute path='/decline' component={RsvpDecline} />
                                    <ProtectedRoute path='/confirm' component={RsvpConfirm} />
                                    <ProtectedRoute path='/registration' component={RsvpRegistration} />
                                    <ProtectedRoute path='/preview' component={RsvpPreview} />
                                    <ProtectedRoute path='/experience' component={Experiance} />
                                    {/* <ProtectedRoute path='/partnership' component={Partnership}/>   // REQUESTED REMOVE LDT-2312 */}
                                    <ProtectedRoute path='/faq' component={Faq} />
                                    <ProtectedRoute path='/myaccount' component={MyProfile} />
                                </Switch>
                            </AppRedirect>
                        </GAListener>
                    </BrowserRouter>
                </AppLoader>
            </Provider>
        );
    }
}

export default App;
